import { createEntityAdapter } from '@ngrx/entity';
import { CampagneSocieteCaracteristiqueEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<CampagneSocieteCaracteristiqueEntityState>;

export const adapter = createEntityAdapter<CampagneSocieteCaracteristiqueEntityState>({
  selectId: o => o.idCampagneSocieteCaracteristique
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const campagneSocieteCaracteristiqueFeatureKey = 'campagneSocieteCaracteristique';
